export class RegExUtils {
    PLATE_NUMBER_RULE = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1,2})$/;
    //PHONE_NUMBER_RULE = /^0?(13[0-9]|14[579]|15[012356789]|16[6]|17[013678]|18[0-9]|19[89]|14[57])[0-9]{8}$/;

    PHONE_NUMBER_RULE = /^0?(13|14|15|16|17|18|19)[0-9]{9}$/;
    ID_CARD_NO_RULE = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    IS_CHINESE = /^[\u4e00-\u9fa5]+$/; // 中文校验
    BUSINESS_LICENSE_PHOTO='business_license_photo'//日期：5-30 所有营业执照上传的目录
    COMPANY_FILE="company_file";
    ID_CARD = 'idcard';  // 身份证正反面、驾驶证、银行卡，营业执照，开户许可证，付款凭证 地址
    BANK_CARD = 'bank_card';//银行卡目录
    TEAM = 'team';//车主协议、现场照片
    AFFILIATION_AGREEMENT = 'affiliation_agreement';//挂靠协议
    TEAM_AGREEMENT = 'team_agreement';//车主协议
    TRUCK = 'truck';     // 车辆证件，人车照片
    WAYBILL = 'waybill';    // 运单照片，发车榜单，回单照片
    APPRAISE = 'Appraise';// 运单评价，投诉
    CONTRACT = 'contract';  // 合同存放目录地址，法大大，协议合同，
    TEMPLATE = 'template';  // 模板存放地址
    SHIPPER_AGREEMENT = 'shipper_agreement'//合同上传地址;
    POLICY1 = 'member_policy1';    //保单上传新地址目录
    POLICY0 = 'member_policy0'; //商业保单上传地址目录
    POLICY4 = 'member_policy4'; //猝死保单上传地址目录
    ORH_CARS = 'orh_member_cars' // 网约车上传地址目录
    SHIP = 'member_ships'//船舶上传文件目录
    INSURE_QUOTE = 'insure_quote'; // 保险报价证件上传目录
    memberInvoice = 'member_invoice';  // 发票存放地址
    TAX_INVOICE = 'taxinvoice'
    IMPORTEXCEL = 'imExcel';                  // 导入excel地址
    EXPORTEXCEL = 'exExcel';                  // 导出excel地址
    RISKWAYBILL = 'riskWabillFile'; //风险处理上传材料地址
    ZIPIMAGE = 'zipImage';
    MEMBER= 'memberlevel';
    BENEFIT_TERM = 'benefit-term';
    SHIPPER_ADVANCE_PAYMENT = 'shipper_advance_payment'; // 货主垫付上传材料地址

}
